import React, { Component } from "react";
import styles from "./FicheClient.local.scss";
import classnames from "classnames";

export default class PresentationListFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 4; i++) {
      items.push(
        <div key={i} className={`${styles.frame} ${styles.gradiant}`}>
          <div className={`${styles.miniature} ${styles.gradiant}`} />
          <div className={styles.frame_details}>
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
          </div>
          <div className={styles.actions}>
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
          </div>
        </div>
      );
    }
    return (
      <div className={`small-12 columns ${styles.presentation_fetching}`}>
        <div className={styles.details}>
          <div className={classnames(styles.gradiant)} />
          <div>
            <div className={classnames(styles.gradiant)} />
            <div className={classnames(styles.gradiant)} />
          </div>
        </div>
        <div className={styles.large_frame}>
          <div className={classnames(styles.gradiant)} />
        </div>
        {items}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FicheClient/PresentationListFetching.js